<script setup>
import {computed, watch, onBeforeUnmount} from 'vue'
import {useRoute} from "vue-router"
import {useFormsStore} from '@/stores/forms'
import {useComponentsStore} from '@/stores/components'
import {useUserStore} from '@/stores/user'
import Form from '@/common/form/Form'
import FormSaveBtn from '@/common/form/FormSaveBtn'

const route = useRoute()
const formsStore = useFormsStore()
const componentsStore = useComponentsStore()
const userStore = useUserStore()

const tableName = 'modulecomponents'

const component = computed(() => componentsStore.items.find(o => o.tableName === route.params.component))
const id = computed(() => component.value?.id)
const formId = computed(() => id.value ? `form:${tableName}:${id.value}` : null)
const user = computed(() => userStore.user)

const initForm = () => {
    if (!id.value) return

    const fieldNames = (user.value?.administrator && component.value?.navigationGroup !== 'Forms')
        ? [
            'title',
            'addNew',
            'updateOption',
            'deleteOption',
            'showStatus',
            'showMetadata',
            'showScheduling',
            'showDisplayOrder',
            'categoryComponent',
            'useArchive'
        ]
        : ['title']

    formsStore.createForm({
        tableName: tableName,
        id: id.value,
        fieldNames: fieldNames
    })
}

watch(id, (newId) => {
    if (newId) {
        initForm()
    }
}, {immediate: true})

onBeforeUnmount(() => {
    if (formId.value) {
        formsStore.deleteForm(formId.value)
    }
})
</script>

<template>
    <div>
        <Form
            v-if="formId"
            :key="formId"
            :id="id"
            :form-id="formId"
            :show-legends="false"
        />

        <footer class="text-center mt-3 mb-3">
            <FormSaveBtn
                :button-text="'Save'"
                :cancel-on-save="true"
                :form-id="formId"
                :default-btn-class="'btn-secondary'"
            />
        </footer>
    </div>
</template>

<style scoped>
legend {
    border: none;
}

.list-group-item {
    border-color: #ebccd1;
}
</style>